var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileProcessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33342 3.04753H3.33341V7.04753H0.666748V0.380859H7.33342V3.04753ZM27.3334 7.04753V0.380859H20.6667V3.04753H24.6667V7.04753H27.3334ZM7.33342 27.0475H3.33341V23.0475H0.666748V29.7142H7.33342V27.0475ZM24.6667 23.0475V27.0475H20.6667V29.7142H27.3334V23.0475H24.6667ZM20.6667 7.04753H7.33342V23.0475H20.6667V7.04753ZM23.3334 23.0475C23.3334 24.5142 22.1334 25.7142 20.6667 25.7142H7.33342C5.86675 25.7142 4.66675 24.5142 4.66675 23.0475V7.04753C4.66675 5.58086 5.86675 4.38086 7.33342 4.38086H20.6667C22.1334 4.38086 23.3334 5.58086 23.3334 7.04753V23.0475ZM18.0001 9.71419H10.0001V12.3809H18.0001V9.71419ZM18.0001 13.7142H10.0001V16.3809H18.0001V13.7142ZM18.0001 17.7142H10.0001V20.3809H18.0001V17.7142Z",
    fill: "#1F6BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileProcessIcon);
export default __webpack_public_path__ + "static/media/FileProcessIcon.5a42d597.svg";
export { ForwardRef as ReactComponent };